<template>
  <div v-if="safeItem" class="pro-info">
    <div class="name">{{ safeItem.name }}</div>
    <div class="bewrite" v-html="safeItem.bewrite"></div>
    <div style="display: flex;gap: 10px;">
    <div class="starting_price">￥<span>{{ safeItem.starting_price }}</span></div>
      <div class="item"><span>{{ safeItem.collection_quantity }}</span> 收藏</div>
      <div class="item"><span>{{ safeItem.positive_review }}</span> 好评</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductInfo',
  props:['item'],
  computed:{
    safeItem(){
        return this.item || null
    }
  }
}
</script>
<style lang="scss" scoped>
.pro-info{
  margin: 10px 10px 10px;
  padding: 15px 10px 15px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  .name {
    font-size: 24px;
    font-weight: 600;
    margin: 8px 0;
  }
  .bewrite {
    font-size: 14px;
    color: #969799;
    margin: 15px 0;
  }
  .starting_price{
    flex: 2;
    span{
      color: red;
      font-size: 20px;
      font-weight: 550;
    }
  }
  .item {
    flex: 1;
    text-align: right;
  }
}
</style>
